import React, { useMemo } from "react";
import PropTypes from "prop-types";
import fields from "../../json/DestroyedFields.json";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import Switch from "Common/Custom/Switch";
import FormSelect from "Common/Custom/FormSelect";

const AddDestroyedForm = ({
  values = {},
  errors = {},
  handleChange = () => { },
  handleSubmit = () => { },
  loading = false,
  ProductOPction = [],
  title = "Create",
}) => {
  const { formdata } = fields;

  // Find the selected product to show total available (stock + laundry ready) in the label
  const selectedProduct = useMemo(
    () => ProductOPction.find((p) => String(p.id) === String(values.product_id)),
    [ProductOPction, values.product_id]
  );

  const renderField = (field) => {
    if (field.type === "select") {
      const options = ProductOPction.map((opt) => ({
        value: opt.id,
        label: opt.product_name,
      }));
      return (
        <FormSelect
          key={field.name}
          field={field}
          value={values[field.name] ?? ""}
          handleChange={handleChange}
          options={options}
          error={errors[field.name]}
        />
      );
    }

    if (field.type === "switch") {
      return (
        <Switch
          key={field.name}
          field={field}
          values={values[field.name]}
          handleChange={handleChange}
          ValueOne="1"
          ValueTwo="0"
          LabelOne="Active"
          LabelTwo="Inactive"
        />
      );
    }

    // Quantity field — show total available (stock + laundry ready) in the label
    if (field.name === "quantity") {
      const dynamicLabel = selectedProduct
        ? `Quantity (Available: ${selectedProduct.total_available} — Stock: ${selectedProduct.stock}, Laundry Ready: ${selectedProduct.laundry_ready})`
        : field.label;

      return (
        <FormInput
          key={field.name}
          field={{ ...field, label: dynamicLabel }}
          value={values[field.name] ?? ""}
          handleChange={handleChange}
          error={errors[field.name]}
        />
      );
    }

    return (
      <FormInput
        key={field.name}
        field={field}
        value={values[field.name] ?? ""}
        handleChange={handleChange}
        error={errors[field.name]}
      />
    );
  };

  return (
    <PageBody
      headerchildren={<HeadingOne>{title}</HeadingOne>}
      onSubmit={handleSubmit}
    >
      {formdata.map(renderField)}

      <FormSubmitButton
        label={title}
        loading={loading}
        colSize="col-12"
        align="end"
      />
    </PageBody>
  );
};

AddDestroyedForm.propTypes = {
  values: PropTypes.object,
  errors: PropTypes.object,
  handleChange: PropTypes.func,
  handleSubmit: PropTypes.func,
  loading: PropTypes.bool,
  ProductOPction: PropTypes.array,
  title: PropTypes.string,
};

export default AddDestroyedForm;
